import { jsonToInputParams } from 'library/util/graph';
import DataQuery from 'library/util/query';
import { resolve } from 'library/helpers/path-resolver';

const dismissOutcome = async (id, outcomeId) => {
  let success;
  let errors;
  try {
    const { data } = await dismissOutcomeMutation({ id, outcomeId });
    const {
      success: mutationSuccess,
      errors: mutationErrors,
    } = dismissOutcomeMutationParseQuery(data);
    success = mutationSuccess;
    errors = mutationErrors;
    if (!success) {
      console.error(mutationErrors);
    }
  } catch (e) {
    console.error(e);
  }
  return {
    success: success,
    errors: errors,
  };
};

const dismissOutcomeMutation = async ({ id, outcomeId }) =>
  await DataQuery(`
    mutation {
      remove_outcome_from_user(
        ${jsonToInputParams({ user_id: id, outcome_id: outcomeId })}
      ) {
        success
        outcome {
          id
          name
        }
      }
    }`);

const dismissOutcomeMutationParseQuery = (data) => ({
  errors: resolve(data, 'remove_outcome_from_user/errors', []),
  user: resolve(data, 'remove_outcome_from_user/user', {}),
  success: resolve(data, 'remove_outcome_from_user/success', false),
});

const dismissRecommendedOutcome = async ({ uuid, outcomeId, entityId }) =>
  await DataQuery(`
    mutation {
      dismiss_recommended_outcome(
        ${jsonToInputParams({
          outcome_id: outcomeId,
          uuid: uuid,
          entity_id: entityId,
        })}
      ) {
        errors {
          path
          message
        }
        success
        user {
          id
        }
      }
    }`);

const dismissRecommendedOutcomeParseQuery = (data) => ({
  errors: resolve(data, 'dismiss_recommended_outcome/errors', []),
  user: resolve(data, 'dismiss_recommended_outcome/user', {}),
  success: resolve(data, 'dismiss_recommended_outcome/success', false),
});

export {
  dismissOutcome,
  dismissOutcomeMutation,
  dismissOutcomeMutationParseQuery,
  dismissRecommendedOutcome,
  dismissRecommendedOutcomeParseQuery,
};
